import _ = require('underscore');
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { currentUserIsAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IDatasourceActions } from '../../datasource/ServerApi/types/IDatasourceActions';
import { IWorkbookActions } from '../../workbook/ServerApi/types/IWorkbookActions';
import { adminDisallowAcceleration } from '../actions/DataAccelerationTaskMenuAction';
import { IAccelerationTaskInfo } from '../models/IAccelerationTaskInfo';

export const AdminDisallowAccelerationAction: IEntityAction<IAccelerationTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.AdminDisallowDataAcceleration,
  translateName: Messages.accelerateDisAllow_action,
  isVisible: isVisible,
  isClickable: isClickable,
  createReduxAction: adminDisallowAcceleration
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IAccelerationTaskInfo[],
  state: AppState
): boolean {
  return FeatureFlags.accelerationSiteAdminUIEnabled
          && currentUserIsAdmin(state)
          && _.any(tasks, (task) => !task.disallowed);
}

function isVisible(
  tasks: IAccelerationTaskInfo[],
  state: AppState,
  availableActions: IWorkbookActions | IDatasourceActions,
): boolean {
  return FeatureFlags.accelerationSiteAdminUIEnabled
          && currentUserIsAdmin(state);
}
